import { Text } from '@src/components';

const BalanceTransfer = () => {
  return (
    <div data-testid="balance-transfer">
      <h1><Text t="balanceTransfer" /></h1>
    </div>
  );
};
export default BalanceTransfer;
